exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1vqdiYRvUJ5qPlm_OM025F{height:100%;min-width:228px;max-width:228px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column;overflow-y:hidden}html[dir] ._1vqdiYRvUJ5qPlm_OM025F{border-color:\"[theme:neutralLight, default:#eaeaea]\"}html[dir=ltr] ._1vqdiYRvUJ5qPlm_OM025F{border-right-width:1px;border-right-style:solid}html[dir=rtl] ._1vqdiYRvUJ5qPlm_OM025F{border-left-width:1px;border-left-style:solid}._3Ur9NqJ63jRSYJq9uNQ3RB{min-height:290px;height:100%;overflow-y:auto}._1bXzDLcqXqO1KnRWus8Mub{height:90px;position:absolute;bottom:20px;display:-webkit-box;display:-ms-flexbox;display:flex}html[dir=ltr] ._1bXzDLcqXqO1KnRWus8Mub{left:36px}html[dir=rtl] ._1bXzDLcqXqO1KnRWus8Mub{right:36px}", ""]);

// exports
exports.locals = {
	"container": "_1vqdiYRvUJ5qPlm_OM025F",
	"fileProviders": "_3Ur9NqJ63jRSYJq9uNQ3RB",
	"localComputer": "_1bXzDLcqXqO1KnRWus8Mub"
};